var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pt-7 pb-11"},[_c('h1',{staticClass:"text-h4 mb-5"},[_vm._v(_vm._s(_vm._f("localize")('quotes')))]),_c('AdminQuotes',{attrs:{"mode":"all"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }